import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import { store } from "./store/store";
import './index.css';
import './assets/css/style.css'
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/learnvnew/learnv5.css';
import './assets/css/learnvnew/groupuser.css';
import './assets/css/learnvnew/responsive.css';
import 'video-react/dist/video-react.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
      <Provider store={store}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
      </Provider>
      </HelmetProvider>
);